export default "__VITE_ASSET__B8L_lomx__"